/*
*###############################################################################
*Module Name                   : VenderMasterEmail.js                          #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : Isuru Sampath Arandara                        #
*Date                          : Tuesday, August 22nd 2023, 9:31:50 am         #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React from "react"
import { Row } from "reactstrap"

import CommonFileUpload from "framework/common/CommonFileUpload"

const CustomerMasterTab8 = ({

    selectedAttachFiles,
    setSelectedAttachFiles,
    attachFileNames,
    setAttachFileNames,
    clearStatus,
    disable,
    clearAttachmentEdit
}) => {

    return (<Row>
        <CommonFileUpload
            selectedAttachFiles={selectedAttachFiles}
            setAttachFileNames={setAttachFileNames}
            attachFileNames={attachFileNames}
            setSelectedAttachFiles={setSelectedAttachFiles}
            clearStatus={clearStatus}
            disable={disable}
            clearAttachmentEdit={clearAttachmentEdit}
            type="Customer"
        />
    </Row>)

}
export default CustomerMasterTab8

